<header id="header" class="clearfix" role="banner" [ngClass]="{
    'collapsed': (remoteVideoVisibility$ | async),
    'hide-header-logo': (hideHeaderLogo$ | async),
    'no-padding-top': (brandingSettings$ | async).removeLogoSpacePaddingTop}">
  @if ((remoteVideoVisibility$ | async)) {
    <a class="header-logo-link" [routerLink]="dashboardRoute" [attr.aria-label]="'SIDEBAR.HOME' | translate">
      <img [src]="(logoUrls$ | async).smallLogoUrl"
        class="header-logo" [alt]="'ACCESSIBILITY.LOGO' | translate">
    </a>
  }
  @if (!(remoteVideoVisibility$ | async)) {
    <a class="header-logo-link" [routerLink]="dashboardRoute" [attr.aria-label]="'SIDEBAR.HOME' | translate">
      <img [src]="(logoUrls$ | async).logoUrl"
        class="header-logo" [alt]="'ACCESSIBILITY.LOGO' | translate">
    </a>
  }
  @if (!(remoteVideoVisibility$ | async)) {
    <a class="header-logo-link" [routerLink]="dashboardRoute" [attr.aria-label]="'SIDEBAR.HOME' | translate">
      <img [src]="(logoUrls$ | async).smallLogoUrl"
        class="mobile-header-logo" [alt]="'ACCESSIBILITY.LOGO' | translate">
    </a>
  }

  <nav class="header-profile" role="navigation" [attr.aria-label]="'ACCESSIBILITY.USER_MENU' | translate">
    <img [src]="(profileData$ | async)?.imageUrl"
      [alt]="'ACCESSIBILITY.PROFILE_IMAGE' | translate"
      class="profile-image">
    <div class="header-text-wrapper clearfix">
      <span class="profile-name">{{(profileData$ | async)?.fullName}}</span>
      @if ((isAuthenticated$ | async)) {
        <button
          type="button"
          id="logout"
          (click)="logout()"
          (keydown.enter)="logout()"
          (keydown.space)="logout()"
          class="logout-button"
          [attr.aria-label]="'ACCESSIBILITY.LOGOUT_BUTTON' | translate">
          <span>
            <i class="fas fa-sign-out" aria-hidden="true"></i>
            {{'LOGOUT' | translate}}
          </span>
        </button>
      }
    </div>
  </nav>
  @if ((brandingSettings$ | async)?.lang?.length > 1) {
    <div class="header-language">
      <app-translation [cssClass]="'header'"></app-translation>
    </div>
  }
</header>
